import { colors } from '@chegg-ui/theme'
import { css } from 'styled-components'

export const SunkistIconColors = css`
  fill: ${({ theme }) => theme.Colors.forInterface.interfaceColor15};
  stroke: ${({ theme }) => theme.Colors.forInterface.interfaceColor15};
`

export const SunkistIconHoverColors = css`
  fill: ${colors.dark};
  stroke: ${colors.dark};
`

export const SunkistIconHoverState = css`
  &:hover {
    ${SunkistIconHoverColors}
  }
`
